<app-form
    (onEscape)="emit_onEscape()"
    [template]="controlsForm"
/>

<ng-template #controlsForm>
    <app-input-control 
        [value]="value_email"  
        [label]="'email'" 
        [readonly]="true"
     />
    <app-input-control #focus
        [value]="value_firstName" 
        [label]="'first name'" 
        [readonly]="true"
     />
    <app-input-control 
        [value]="value_lastName"  
        [label]="'last name'" 
        [readonly]="true"
     />
    <app-input-control 
        [value]="value_applicationName"  
        [label]="'application name'" 
        [readonly]="true"
     />
    <app-input-control 
        [value]="value_correspondenceName"  
        [label]="'correspondence name'" 
        [readonly]="true"
     />
</ng-template>
